import { render, staticRenderFns } from "./EarthquakeReport.vue?vue&type=template&id=6f71dfda&"
import script from "./EarthquakeReport.vue?vue&type=script&lang=js&"
export * from "./EarthquakeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports